import React from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, Lock, ArrowLeft, Home } from "lucide-react";

export const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: "100vh", background: "#09090b", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }} data-testid="page-404">
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: "5rem", fontWeight: 900, color: "rgba(250,204,21,0.15)", lineHeight: 1 }}>404</div>
        <AlertTriangle size={32} style={{ color: "#FACC15", margin: "16px auto" }} />
        <h1 style={{ fontSize: "1.4rem", fontWeight: 700, color: "#fff", marginBottom: "8px" }}>Page not found</h1>
        <p style={{ color: "#a1a1aa", fontSize: "0.88rem", marginBottom: "24px" }}>The page you're looking for doesn't exist or has been moved.</p>
        <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
          <button onClick={() => navigate(-1)} style={{ padding: "10px 20px", background: "transparent", border: "1px solid rgba(255,255,255,0.15)", borderRadius: "4px", color: "#a1a1aa", cursor: "pointer", fontSize: "0.85rem", display: "flex", alignItems: "center", gap: "6px" }}>
            <ArrowLeft size={14} /> Go Back
          </button>
          <button onClick={() => navigate("/")} style={{ padding: "10px 20px", background: "#FACC15", border: "none", borderRadius: "4px", color: "#000", cursor: "pointer", fontWeight: 700, fontSize: "0.85rem", display: "flex", alignItems: "center", gap: "6px" }}>
            <Home size={14} /> Home
          </button>
        </div>
      </div>
    </div>
  );
};

export const Forbidden = () => {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: "100vh", background: "#09090b", display: "flex", alignItems: "center", justifyContent: "center", padding: "24px" }} data-testid="page-403">
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: "5rem", fontWeight: 900, color: "rgba(239,68,68,0.15)", lineHeight: 1 }}>403</div>
        <Lock size={32} style={{ color: "#f87171", margin: "16px auto" }} />
        <h1 style={{ fontSize: "1.4rem", fontWeight: 700, color: "#fff", marginBottom: "8px" }}>Access Denied</h1>
        <p style={{ color: "#a1a1aa", fontSize: "0.88rem", marginBottom: "24px" }}>You don't have permission to view this page.</p>
        <button onClick={() => navigate("/")} style={{ padding: "10px 20px", background: "#FACC15", border: "none", borderRadius: "4px", color: "#000", cursor: "pointer", fontWeight: 700, fontSize: "0.85rem" }}>
          Go to Homepage
        </button>
      </div>
    </div>
  );
};
